// V1 intake step names, used as keys for their translated labels (common/i18n/staticStepLabels.ts)
export const INITIAL_DETAILS = 'Initial details';
export const SELLER_INFORMATION = 'Seller(s) information';
export const MAILING_INFO = 'Mailing info';
export const PROPERTY_DETAILS = 'Property Details';
export const CURRENT_ADDRESS = 'Current address';
export const PURCHASER_INFORMATION = 'Purchaser(s) information';
export const BORROWER_INFORMATION = 'Borrower(s) information';
export const LENDER_INFORMATION = 'Lender(s) information';
